/**
 * Tour ids:
 * - Dashboard: staff | member | investor
 * - Modules: staff_contributions, staff_loans, member_contributions, member_loans
 */
function storageKey(tourId) {
  if (!tourId) return null;
  return `has_seen_tour_${tourId}`;
}

export function hasSeenTour(tourId) {
  const key = storageKey(tourId);
  if (!key || typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

export function markTourSeen(tourId) {
  const key = storageKey(tourId);
  if (!key || typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, "1");
  } catch {
    // ignore quota / private mode
  }
}

export function resetTour(tourId) {
  const key = storageKey(tourId);
  if (!key || typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore
  }
}
